export default {
    "label.update_translations_unsuccessful": "",
    "global.no_records": "Nėra įrašų",
    "notifications.rp_has_been_updated": "Aukso rezidavimo projektas atnaujintas",
    "moduleTitle.files": "Failai",
    "label.coordinator": "Koordinatorius",
    "sidebar.translations_managment": "",
    "table.file": "Failas",
    "label.report_overview": "",
    "label.parent_agreement": "Tėvų patvirtinimas",
    "parentalConsent.i_consent_to_and_understand_that": "6. Sutinku ir suprantu, kad dalyvio padarytos nuotraukos, susijusios su DofE programa ir dalyvavimu joje, gali būti naudojamos programos viešinimo tikslais. Dalyvis bei tėvas/globėjas pasirašė sutikimą tinkamai naudoti nuotraukas.",
    "parentalConsent.i_understand_that_participants_are_required_to_comply": "12. Suprantu, kad dalyviai privalo sutikti su DofE programos reikalavimais, politika ir standartais (kurie nurodyti e-DofE platformoje ir yra nuolat pildomi), nustatytais DofE programos koordinatoriaus ir DofE organizacijos. Reikalavimai yra susiję su avarinėmis situacijomis, veiklų vertinimu ir elgesiu žygio metu. Suprantu, kad DofE organizacija gali atmesti dalyvio dalyvavimą programoje, jei nėra laikomasi taisyklių.",
    "table.end_date": "Pabaigos data",
    "label.activation_date": "Sudarymo data",
    "label.report": "",
    "label.award_is_offline": "Apdovanojimas neprisijungęs",
    "label.pending_changes": "Laukiama pakeitimų...",
    "errors.min_nights_required": "reikalaujamas minimalus {nights} naktų skaičius ",
    "label.country": "Šalis",
    "notifications.award_leader_has_been_returned": "DofE vadovas peržiūrėtas",
    "notifications.participant_has_been_updated": "Dalyvis atnaujintas",
    "label.phone_number": "Telefono numeris",
    "roles.aj_assessor": "Žygio Vertintojas",
    "notifications.person_state_has_been_changed": "Asmens statusas pakeistas",
    "pageTitle.dashboard": "Pagrindinis ekranas",
    "moduleTitle.global_payment_method": "Tarptautinis apmokėjimo būdas",
    "label.organization_type": "Organizacijos tipas",
    "button.account_settings": "Paskyros nustatymai",
    "notifications.contact_has_been_updated": "Kontaktas atnaujintas",
    "participant.recover_password": "Atnaujinti slaptažodį",
    "notifications.assessment_request_has_been_sent": "Įvertinimo prašymas išsiųstas",
    "button.unassign": "",
    "label.start_date": "Pradžios data",
    "label.assign_labels": "",
    "sidebar.participants": "Dalyviai",
    "roles.coordinator": "Koordinatorius",
    "label.organization_contact": "Organizacijos kontaktai",
    "tabs.customization": "Pritaikymas",
    "sidebar.award_units": "DofE  organizacijos",
    "button.change_goal": "Keisti tikslą",
    "translationsManagement.selectProject": "",
    "award.rp": "Aukso rezidavimo projektas",
    "label.size": "Dydis",
    "label.bulk_action_results": "",
    "notifications.activity_has_been_approved": "Veikla patvirtinta",
    "label.payment_type": "",
    "button.gop_assignment": "",
    "button.resend_assessment_request": "persiųsti įvertinimo prašymą",
    "notifications.template_has_been_removed": "Kortelė buvo pašalinta",
    "button.award_settings": "Apdovanojimo lygio nustatymai",
    "pageTitle.payment": "Mokėjimas",
    "tasks.return_award": "Grąžinti Apdovanojimą",
    "label.link": "nuoroda",
    "moduleTitle.award_participant_delete": "",
    "pageTitle.mro_related_contacts": "Mano regiono centras - susiję kontaktai",
    "pageTitle.my_organization_labels": "",
    "tabs.activity_signoff": "Dalies patvirtinimas",
    "table.logs": "Įrašai",
    "moduleTitle.remove_file": "Pašalinti failą?",
    "label.email_confirmed": "El. pašto adresas patvirtintas",
    "notifications.activity_has_been_returned": "Veikla peržiūrėta",
    "label.note": "Žinutė",
    "button.show": "",
    "tabs.adventurous_journey": "Žygis",
    "sidebar.my_todolist": "",
    "label.here": "Čia",
    "organisation.change_award_mode": "Keisti Apdovanojimo režimą",
    "table.note_from_al": "Žinutė iš DofE vadovo",
    "label.gender": "Lytis",
    "moduleTitle.remove": "Pašalinti?",
    "errors.must_be_less_than": "Turi būti mažiau nei {limit}",
    "button.logout": "Atsijungti",
    "label.no_selected_participants": "Nėra pasirinktų dalyvių",
    "button.new_aj_event": "Naujas žygio įvykis",
    "label.employement_status": "Užimtumo statusas",
    "tabs.logs": "Įrašai",
    "tabs.contacts": "Kontaktai",
    "label.option": "Pasirinkimai",
    "dashboard.charts": "Lentelės",
    "notifications.rp_has_been_approved": "Aukso rezidavimo projektas patvirtintas",
    "pageTitle.new_participant": "Naujas dalyvis",
    "notifications.award_leader_has_been_approved": "DofE vadovas patvirtintas",
    "moduleTitle.would_you_like_to_remove_leader_training": "Norite ištrinti DofE vadovo apmokymą?",
    "moduleTitle.update_configuration_value": "Atnaujinti konfigūracijos vertę",
    "table.description": "Aprašymas",
    "table.organization": "Organizacija",
    "label.youtube": "YouTube",
    "label.author": "Autorius",
    "table.suitable_for_award_level": "Tinkamas Apdovanojimo lygiui",
    "label.content_update": "Prašome palaukti. Įkeliamas turinys...",
    "notifications.new_question_has_been_added": "Pridėtas naujas klausimas",
    "pageTitle.nao_awards": "DofE Lietuva - Apdovanojimai",
    "table.last_name": "Pavardė",
    "moduleTitle.adventurous_journey_detail": "Žygio detalės",
    "Description of the combo box selection in bulk operation panel": {"label.bulk_operations": ""},
    "label.project_location_type": "Projekto vietos tipas",
    "label.email_help_award_level": "",
    "label.date": "Data",
    "label.previous_completed_award_place": "Kur",
    "button.show_more": "Rodyti daugiau",
    "label.wwc_number": "\n WWC number",
    "button.filter": "Filtras",
    "notifications.rp_has_been_returned": "Aukso rezidavimo projektas grąžintas",
    "pageTitle.residetial_project_assessor_report": "Aukso rezidavimo projektas - Vertintojo ataskaita",
    "label.generating": "Kuriama...",
    "moduleTitle.finance_system_data": "Finansinės sistemos duomenys",
    "notifications.adventurous_journey_state_has_been_changed": "Žygio būsena pakeista",
    "route.levels": "Lygiai",
    "moduleTitle.activity_leader": "Veiklos vadovas",
    "tasks.approve_event": "Patvirtinti įvykį",
    "tasks.reject_event": "Atmesti įvykį",
    "table.region": "Regionas",
    "pageTitle.nao_award_leaders": "DofE Lietuva - DofE vadovai",
    "errors.must_be_at_least": "Turi turėti bent {min} ženklus",
    "table.title": "Pavadimas",
    "table.last_activity": "Paskutinė veikla",
    "tasks.delete_registration": "Ištrinti registraciją",
    "table.date_time": "Data / Laikas",
    "parentalConsent.the_award_operators_are_committed_to_respecting": "14. DofE Lietuva įsipareigoja gerbti jūsų privatumą. Asmeninė informacija yra šioje platformoje yra naudojama tik dalyvio dalyvavimo DofE programoje tikslais. Dalyviai, nepateikę šios informacijos, negali dalyvauti DofE programoje (pažymima, kad tai negalioja nepatvirtintiems dalyvių duomenims). Mes naudojame asmeninius duomenis tam, kad galėtume Jums atsiųsti reikalingą informaciją apie DofE programos veiklas, taip pat dalinamės šia informacija su kitomis vietos ar tarptautinėmis DofE organizacijomis ar paslaugų tiekėjais, kurie padeda administruoti DofE programą. Jei norite susisiekti su mumis ar prieiti prie savo asmeninės informacijos, susisiekite su DofE Lietuva komanda. Taip pat DofE Lietuva gali Jums išduoti savo privatumo politikos kopiją. ",
    "aj.practice_journey": "Bandomasis žygis",
    "notification.log_has_been_restored": "Veiklos įrašas buvo atkurtas",
    "tabs.my_participants": "Mano dalyviai",
    "label.bulk_action_assign_label": "",
    "moduleTitle.supervisor": "Žygio vadovas",
    "moduleTitle.your_parental_consent": "Tėvų sutikimas",
    "route.registration_participants": "Dalyvių registracijos",
    "placeholder.start_typing": "Pradėti rašyti...",
    "tasks.approve_award": "Patvirtinti Apdovanojimą ",
    "route.registrations": "Registracijos",
    "button.add_activity": "",
    "notifications.aj_event_has_been_created": "Žygio įvykis sukurtas",
    "states.supervisor_approval": "Vertintojo patvirtinimas",
    "label.description": "Apibūdinimas",
    "button.leave_anyway": "Išeiti",
    "tabs.registrations": "Registracijos",
    "states.leader_signoff": "",
    "moduleTitle.forbidden": "",
    "notifications.translations_has_been_updated.button": "",
    "pageTitle.nao_registration": "DofE Lietuva - Registracija",
    "pageTitle.mro_logs": "Mano regiono centras - Prisijungimai",
    "meta.page_not_found": "Puslapis nerastas",
    "label.bulk_action_unsuccessful": "",
    "global.days": "dienos",
    "table.review": "Peržiūra",
    "table.as_assessor_for": "kaip vertintojas",
    "roles.if_staff_statistical_user": "Tarptautinio fondo statistikos vartotojas",
    "table.levels": "Lygiai",
    "label.suitable_for_level": "Tinkamas lygiui",
    "pageTitle.leaders": "DofE vadovas",
    "moduleTitle.send_test_email": "Siųsti bandomąjį laišką",
    "pageTitle.tasks_removed_registration": "Pašalinti dalyvių registracijų duomenys",
    "label.you_will_be_forced_to_login_again_after_change": "Po pakeitimo būsite priversti prisijungti dar kartą",
    "table.recent_updates": "",
    "pageTitle.tasks_activity_signoffs": "Dalies patvirtinimas",
    "pageTitle.payments": "Mokėjimai",
    "global.nights": "naktys",
    "label.blank_any_level": "",
    "button.view_section": "",
    "moduleTitle.select_organization": "Pasirinkti organizaciją",
    "pageTitle.manual_data_import": "",
    "button.upload_files": "Įkelti failus",
    "label.migrated_contact_email": "Perkeltas el. pašto adresas",
    "label.for_award_unit": "DofE organizacijai",
    "label.aj_template_note": "Šablono pastaba",
    "table.last_log_added": "",
    "button.view_participant": "",
    "label.please_comment_on_the_participants": "Pakomentuokite, kaip dalyvis patobulėjo/ atliko veiklas/ vykdė įsipareigojimus",
    "label.consent_already_given_login": "Sutikimas duotas. Prašome prijungti vaiką",
    "participant.level_start_date": "{value} pradžios data",
    "sidebar.my_region_office": "Mano regiono centras",
    "states.section_signoff": "Lygio patvirtinimas",
    "moduleTitle.assessor_details": "Vertintojo duomenys",
    "moduleTitle.adventurous_journey_settings": "Žygio nustatymai",
    "moduleTitle.note_from_al": "Žinutė DofE vadovui",
    "button.add_role": "Pridėti rolę",
    "table.run": "Diegti",
    "states.change_to_state_warning_missing_assessment": "",
    "label.user_app_guide_leader": "Naudotojo aplikacijos vadovas - vadovs",
    "tabs.section_approval": "Dalies patvirtinimas",
    "roles.award_verifier": "Apdovanojimo patvirtinimas",
    "tabs.activity_approval": "Veiklos patvirtinimas",
    "logs.add_log": "Pridėti įrašą",
    "tabs.award": "Apdovanojimas",
    "notifications.this_role_has_read_only_persmission": "Ši rolė turi tik skaitymo teises",
    "table.no_filtered_results": "Nerasta duomenų",
    "button.praise": "",
    "label.prevent_welcome_email_assessor": "",
    "label.location_detail": "Vietos detalės",
    "label.optional": "(neprivaloma)",
    "errors.do_not_match": "Neatitinka",
    "label.use_comma_for_multiple_entries": "Naudokite kablelį keliems įrašams",
    "label.operating_authority": "DofE Lietuva partneris",
    "label.activity_section": "Veiklos dalis",
    "notifications.you_have_been_logged_out": "Jūs buvote išregistruotas",
    "table.finished": "Baigta",
    "button.same_as_billing": "Same as Billing",
    "table.payment": "Mokėjimas",
    "table.current_level": "Dabartinis lygis",
    "button.view_nao": "",
    "table.email_confirmation": "El. pašto adreso patvirtinimas",
    "moduleTitle.shipping_address": "Pristatymo adresas",
    "label.secondary_phone_type": "Antro telefono tipas",
    "notifications.saved": "Išsaugota",
    "pageTitle.all_participants": "Visi dalyviai",
    "label.first_name": "Vardas",
    "label.oa_price": "Apdovanojimo lygio kaina",
    "table.award_mode": "Apdovanojimo režimas",
    "tabs.api_keys": "",
    "award.award_detail": "Informacija apie apdovanojimą",
    "tabs.user_management": "Vartotojo valdymas",
    "tabs.all_events": "Visi įvykiai",
    "notifications.history_record_has_been_removed": "Istorijos įrašas panaikintas",
    "award.no_data": "Nėra duomenų",
    "notifications.preparation_training_has_been_added": "Pasiruošimas ir žygio planavimas pridėtas",
    "label.message": "Pranešimas",
    "notifications.participant_info_updated": "Participant information has been updated",
    "roles.nao_staff": "DofE Lietuva personalas",
    "tabs.adventurous_journeys": "Žygis",
    "label.gops": "",
    "route.upload": "Įkelti",
    "notifications.history_record_has_been_added": "Istorijos įrašas pridėtas",
    "notifications.history_record_has_been_updated": "Istorijos įrašas atnaujintas",
    "label.no_data": "Nėra duomenų",
    "button.add_coordinator": "Pridėti koordinatorių",
    "label.you_are_already_logged_as": "Jūs jau priregistruotas kaip",
    "route.my_national_office": "Mano nacionalinis centras",
    "tabs.leaders": "DofE vadovai",
    "label.email_confirmation": "El. pašto patvirtinimas",
    "table.registration_date": "Registracijos data",
    "notifications.role_has_been_removed": "Vaidmuo pašalintas",
    "button.move": "Perkelti",
    "label.terms_and_conditions": "",
    "pageTitle.detail": "Detalės",
    "table.award_unit": "DofE organizacija",
    "sidebar.settings": "Nustatymai",
    "dashboard.leader_state": "DofE vadovai - pagal būseną",
    "notifications.award_unit_has_been_approved": "DofE organizacija buvo patvirtinta",
    "states.awaiting_approval": "Laukiama patvirtinimo",
    "table.level": "Lygis",
    "table.action_requested": "",
    "label.organisation_mode": "Organizacijos režimas",
    "label.no_note": "Žinučių nėra",
    "tabs.my_events": "Mano įvykiai",
    "notifications.participants_have_been_added": "Dalyviai pridėti",
    "tabs.registration_questions": "",
    "button.delete_registration": "Ištrinti registraciją",
    "notifications.parental_consent_link_has_been_sent": "Tėvų sutikimo nuoroda persiųsta",
    "moduleTitle.select_role_organization": "Pasirinkti rolę ir organizaciją",
    "label.experience": "Patirtis",
    "translationsManagement.modal.title": "",
    "table.ic": "Nepriklausoma šalis",
    "table.id": "Identifikavimo numeris",
    "label.notify_email_explanation": "",
    "participant.would_you_like_to_remove": "Norite ištrinti šią paskyrą?",
    "table.fields_included": "",
    "label.user_guide_web_leader": "Elektroninis naudotojo vadovas - vadovas",
    "label.journey_type": "Žygio tipas",
    "button.setup": "Nustatymas",
    "tabs.my_national_office": "Mano nacionalinis centras",
    "notifications.training_has_been_removed": "Mokymasis pašalintas",
    "label.nominated_and_identified_persons": "Paskirti žmonės, kurie gali matyti ir redaguoti duomenis",
    "moduleTitle.you_have_been_logged_out_due_to_inactivity": "Jūs buvo atjungtas nuo sistemos, kadangi ilgą laiką buvote neaktyvus",
    "states.award_leader_signoff": "DofE vadovo patvirtinimas",
    "table.award_signoff_attempts": "Apdovanojimo lygio pateikimai",
    "sidebar.regions": "Regionai",
    "label.activity_deleted_note": "Ši veikla yra ištrinta. Ją galite atkurti paspaudus žemiau esantį mygtuką. ",
    "table.total": "Iš viso",
    "errors.a_problem_has_occured_during_processing": "Apdorojimo metu iškilo problema, žr. Daugiau informacijos",
    "participant.participant_already_has_gold_award": "Dalyvis jau turi aukso ženklelį",
    "pageTitle.mro": "Mano regiono centras",
    "notifications.authorization_code_has_expired": "Prisijungimo kodo galiojimo laikas baigėsi",
    "moduleTitle.child_organization_labels": "",
    "aj.aj_events": "Žygio įvykis",
    "global.loading": "Kraunama",
    "label.gnipp": "",
    "sidebar.registrations": "Registracijos",
    "label.any_string": "Bet kuri dalis",
    "contact.change_contact_status": "Pakeiskite kontakto statusą",
    "tabs.registration": "Registracijos",
    "label.override_payment_note": "Nepaisyti pranešimo apie mokėjimą",
    "notifications.section_has_been_signed_off": "Dalis patvirtinta",
    "label.payment_date": "Mokėjimo data",
    "button.approve": "Patvirtinti",
    "moduleTitle.loggin_in": "Prisijungiama",
    "label.website": "Tinklapis",
    "label.role": "Vaidmuo",
    "table.assessor_report": "Vertintojo ataskaita",
    "label.ue_fe": "",
    "label.please_comment_on_the_participants_effort": "",
    "label.previously_worked_as_assessor": "Anksčiau dirbo kaip vertintojas",
    "pageTitle.registrations": "Registracijos",
    "parentalConsent.this_form_must_be_completed": "Ši forma <strong>must</strong> turi būti užpildyta tėvų/globėjų, kurių vaikai yra jaunesni nei 18 metų pagal šalies, kurioje gyvenate </strong>,  teisinius įstatymus.",
    "button.apply": "",
    "errors.include_at_least_one_number": "Įtraukite bent vieną skaitmenį",
    "label.content_restore": "Sesija atnaujinama",
    "logs.hour": "valandos",
    "parentalConsent.i_have_read_and_understand": "7. Perskaičiau ir suprantu DofE programos lygius bei reikalavimus, kurie yra aprašyti programos vykdymo sąlygose (žiūrėti šios formos 5 puslapį).",
    "notifications.award_was_deleted": "",
    "label.journey_category": "Žygio tipas",
    "notifications.search_cancelled": "Paieška buvo nutraukta,palaukite, kol paieška baigsis",
    "route.detail": "Duomenys",
    "route.user_guide": "Vartotojo vadovas",
    "moduleTitle.history": "Istorija",
    "table.gop_name": "",
    "pageTitle.tasks_unassigned_participants": "Nepaskirtas dalyvis",
    "states.inactive": "Neaktyvus",
    "pageTitle.search_results": "Paieškos rezultatai",
    "button.proceed_to_login": "Tęsti ir prisijungti",
    "pageTitle.assessor_report_reject": "Vertintojo ataskaitos atmetimas",
    "notifications.contact_has_been_removed": "Kontaktas pašalintas",
    "sidebar.operating_authorities": "DofE Lietuva partneriai",
    "label.no_note_from_participant": "",
    "aj.preparation_and_training": "Pasiruošimas ir mokymasis",
    "route.user_guide_web_leader": "Elektroninis naudotojo vadovas - vadovas",
    "label.position_in_organization": "Pozicija organizacijoje",
    "errors.emails_dont_match": "El. pašto adresai neatitinka",
    "route.my_participants": "Mano dalyviai",
    "pageTitle.customisations": "Pateikimas",
    "tabs.localization_files": "Lokalizacijos failai",
    "table.assessor_approval": "Vertintojo patvirtinimas",
    "tabs.related_contacts": "Susiję kontaktai",
    "table.aus": "DofE organizacijos",
    "table.category": "",
    "errors.file_is_too_large": "",
    "label.possible_values": "Galimos vertės",
    "label.if_your_download_doesnt_start": "Jei parsisiųstas failas neatsidaro automatiškai, paspauskite",
    "route.independent_award_centres": "Nepriklausomos DofE organizacijos",
    "pageTitle.user_guide": "Vartotojo vadovas",
    "button.visit": "",
    "label.hours_first_letter": "val",
    "pageTitle.my_organization_detail": "Mano organizacija - Duomenys",
    "pageTitle.nao_detail": "DofE Lietuva - Duomenys",
    "button.change": "Keisti",
    "award.aj": "Žygis",
    "table.award_state": "Apdovanojimo lygio būsena",
    "pageTitle.tasks_award_signoff": "Apdovanojimo lygio patvirtinimas",
    "pageTitle.regions": "Regionai",
    "notifications.award_has_been_signed_off": "Apdovanojimas patvirtintas",
    "dashboard.award_approved_by": "Patvirtinti Apdovanojimo lygiai - 2016 metais",
    "tabs.new_template": "Naujas šablonas",
    "error.parent_email_must_be_filled": "Turi būti įrašytas tėvų el.paštas",
    "label.organisation_invoicing_name": "Organizacijos sąskaitų faktūrų pavadinimas",
    "pageTitle.related_contacts": "Susiję kontaktai",
    "button.try_again": "Uždarykite puslapį ir bandykite dar kartą",
    "label.cannot_be_change_to_another": "Negali būti pakeistas į kitą apdovanojimo lygį",
    "notifications.lead_coordinator_has_been_set": "Nustatytas naujas pagrindinis koordinatorius",
    "label.training_name": "Mokymų pavadinimas",
    "moduleTitle.new_contact": "Naujas kontaktas",
    "translationsManagement.modal.updateTitle": "",
    "moduleTitle.offline_award_units_signoff": "Neprisijungusio DofE vadovo patvirtinimas",
    "notifications.award_level_has_been_changed": "Apdovanojimo lygis buvo pakeistas",
    "label.subject": "Tema",
    "route.silver_level": "Sidabro lygis",
    "label.privacy_notice": "",
    "label.switch_organization": "Keisti organizaciją",
    "meta.dofe_name": "The Duke of Edinburgh’s Award",
    "route.profile": "Profilis",
    "roles.super_user": "Super vartotojas",
    "dashboard.while_you_were_gone": "Kol Jūsų nebuvo",
    "label.no_note_from_award_leader": "",
    "label.middle_name": "Vidurinis vardas",
    "moduleTitle.new_activity": "Nauja veikla",
    "organisation.would_you_like_to_remove": "Ar norite pašalinti šią organizaciją?",
    "label.state_province": "Regionas",
    "moduleTitle.your_home_address": "Namų adresas",
    "tabs.sign_offs": "Patvirtinimai",
    "moduleTitle.logs": "Įrašai",
    "button.view_more": "Rodyti daugiau",
    "label.profile": "Profilis",
    "label.title": "Pavadinimas",
    "tabs.award_signoff": "Apdovanojimo patvirtinimas",
    "label.post_code": "Pašto kodas",
    "states.ceremony_certificate": "Ceremonija ir sertifikatas",
    "label.code": "",
    "parentalConsent.i_consent_to_the_provision_of_any": "13.  Sutinku visą asmeninę informaciją (įskaitant dalyvio duomenis) pateikti DofE organizacijai. Sutinku, kad ši informacija būtų naudojama pagal privatumo politikos dokumentus, pateiktus DofE Lietuva biuro. Šie dokumentai gali būti pildomi ir taisomi pagal Data Protection Act (UK) 1998 bei kitus privatumo politikos dokumentus, standartus, gaires ar instrukcijas. \n",
    "label.user_guide_web_participant": "Elektroninis naudotojo vadovas - dalyvis",
    "label.award_unit_type": "DofE organizacijos tipas",
    "states.complete": "",
    "table.participant_state": "Dalyvio būsena",
    "pageTitle.my_organization_payment": "Mano organizacija - Mokėjimas",
    "table.approved": "Patvirtinta",
    "pageTitle.my_organization_contacts": "Mano organizacija - Kontaktai",
    "warning.award_marked_as_paid_registration": "",
    "states.change_to_state": "Pakeisti į <strong>{state}</strong> būseną?",
    "label.integer": "Pateikimas",
    "notifications.translationUpdateInterrupted": "",
    "notifications.password_has_been_changed": "Slaptažodis pakeistas",
    "button.invite_assessor": "Pakviesti vertintoją",
    "label.other_activity": "Kita veikla",
    "notifications.parental_consent_has_been_sent": "Tėvų sutikimas gautas",
    "button.revise": "Atmesti",
    "errors.end_date_must_be_after_start_date": "Pabaigos data turi būti vėlesnė nei pradžios data",
    "label.award_leader_signoff_date": "DofE vadovo patvirtinimo data",
    "parentalConsent.i_understand_every_participant_must": "8. Suprantu, kad dalyvis gali dalyvauti programoje tik DofE organizacijoje, kuri turi teisę priimti ir atmesti dalyvius bei jų pasirinktas vykdyti veiklas.",
    "moduleTitle.policies": "",
    "pageTitle.tasks_aj": "Žygis",
    "global.day": "diena",
    "moduleTitle.coordinator": "Koordinatorius",
    "label.region": "Regionas",
    "button.add_history_record": "Pridėti įrašą prie istorijos",
    "moduleTitle.adventurous_journey_template_settings": "Žygio kortelės nustatymai",
    "notifications.personal_details_have_been_updated": "Asmeniniai duomenys atnaujinti",
    "sidebar.ics": "Nepriklausomos šalys",
    "table.independent_award_centre": "Nepriklausoma DofE organizacija",
    "label.undelivered_mail_reason": "",
    "table.utc_date_time": "",
    "moduleTitle.emails": "El.pašto adresai",
    "label.backoffice": "",
    "moduleTitle.parent_consent": "Tėvų/globėjų sutikimas",
    "label.photo_consent_given": "Dalyvis sutinka, kad jo profilio nuotrauka gali būti naudojama reklamos tikslais",
    "moduleTitle.authorising_contact": "Įgaliotas kontaktinis asmuo",
    "label.assessment_with_role": "{role} įvertinimas",
    "dashboard.type_of_awards": "DofE organizacijos tipas",
    "moduleTitle.payment": "Mokėjimas",
    "states.in_progress": "Procese",
    "logs.no_logs": "Nėra įrašų",
    "sidebar.my_office": "Mano ofisas",
    "label.assessor_report": "Vertintojo ataskaita",
    "notifications.rp_has_been_signed_off": "Aukso rezidavimo projektas patvirtintas",
    "tabs.labels": "",
    "sidebar.payments": "Mokėjimai",
    "meta.profile_questions": "Profilio klausimai",
    "label.fax": "Faksas",
    "label.email_help_custom_link": "",
    "label.last_name": "Pavardė",
    "organisation.manage_gop": "",
    "table.parental_consent": "",
    "dashboard.participant_by_level": "Dalyviai - pagal lygį",
    "tabs.award_leaders": "DofE vadovai",
    "label.i_confirm_that_ive_witnessed": "Patvirtinu, kad stebėjau dalyvių įrašus toliau nurodytai veiklai",
    "table.lead_coordinator": "",
    "states.deleted": "Ištrinta",
    "label.no_answers": "Nėra atsakymo",
    "button.add": "Pridėti",
    "label.exchequer_number": "Sąskaitos numeris",
    "label.waiting": "Laukiama",
    "label.email_help_person_full_name": "",
    "tasks.return_registration": "Grąžinti peržiūrai",
    "notifications.state_aj_preparation_training_has_been_changed": "",
    "label.parent_approval": "Tėvų patvirtinimas",
    "table.assessor_approve": "Vertintojo patvirtinimas",
    "errors.some_fields_requires_your_attention": "Peržiūrėkite kai kuriuos laukelius",
    "aj.qualifying_journey": "Kvalifikacinis žygis",
    "route.awards": "Apdovanojimai",
    "table.registration": "Registracija",
    "pageTitle.assessors": "Vertintojai",
    "notifications.award_has_been_updated": "Apdovanojimo lygis atnaujintas",
    "errors.must_be_one_of": "Turi būti vienas iš: {enums}",
    "pageTitle.logs": "Prisijungimai",
    "notifications.notifications.invitation_has_been_sent": "Kvietimas išsiųstas",
    "route.national_offices": "Nacionaliniai centrai",
    "notifications.training_has_been_updated": "Mokymasis atnaujintas",
    "label.parent_last_name": "Tėvų/globėjų  pavardė",
    "table.leaders": "DofE vadovai",
    "states.award_level_complete": "Apdovanojimo lygis baigtas",
    "button.reset": "Nustatyti iš naujo",
    "sidebar.my_award_unit": "Mano DofE organizacija",
    "pageTitle.all_aj_events": "Visi žygio įvykiai",
    "label.activity": "Veikla",
    "moduleTitle.are_you_sure": "Tikrai?",
    "route.gold_level": "Aukso lygis",
    "table.evidence": "Įrodymas",
    "label.delivery_confirmed": "Pristatymas patvirtintas",
    "parentalConsent.as_the_parent": "Kaip tėvas/globėjas suteikiu biurui leidimą naudoti e-DofE platformoje esančią vaizdinę medžiagą.",
    "label.awardMode.offline": "Neprisijungęs",
    "tasks.approve_registration": "Patvirtinti registraciją",
    "note.change_the_email_will_change": "Žinutė: pakeistas el. pašto adresas pakeis ir perkeltą el. pašto adresą",
    "notifications.participant_has_been_approved": "Dalyvis patvirtintas",
    "label.reached_activity_limit": "Šioje dalyje nebegalite pridėti daugiau veiklų. Kiekvienoje dalyje dalyvis gali turėti daugiausia 3 veiklas.",
    "label.facebook": "Facebook",
    "notifications.label_has_been_removed": "",
    "label.action_required": "",
    "notifications.preparation_training_has_been_removed": "Pasiruošimas ir žygio planavimas pašalintas",
    "pageTitle.settings": "Nustatymai",
    "participant.level_registration_date": "{value} Registracijos data",
    "notifications.question_has_been_removed": "Klausimas buvo pašalintas",
    "label.email_help_award_leader_full_name": "",
    "sidebar.leaders": "DofE vadovai",
    "notifications.participants_have_been_transferred": "Dalyviai perkelti",
    "tabs.assessors": "Vertintojai",
    "sidebar.dashboard": "Pagrindinis puslapis",
    "pageTitle.independent_award_centers": "Nepriklausomos DofE organizacijos",
    "label.search": "Ieškoti",
    "moduleTitle.office_labels": "",
    "label.note_from_participant": "Žinutė dalyviui",
    "errors.required_field": "Privalomas laukas",
    "tasks.approve_task": "Patvirtinti veiklą",
    "logs.edit_log": "Redaguoti įrašą",
    "table.state": "Būsena",
    "moduleTitle.level_summary": "",
    "moduleTitle.guides": "",
    "modal.close": "Uždaryti",
    "label.parent_first_name": "Tėvų/globėjų vardas",
    "parentalConsent.i_understand_that_the_participant": "1. Suprantu, kad dalyvis negali dalyvauti Programoje, kol ši forma nėra užpildyta (įtraukiant tėvų/globėjų sutikimą) ir grąžinta DofE vadovui kartu su sumokėtu Dalyvio registracijos mokesčiu. ",
    "tabs.award_units": "DofE organizacijos",
    "table.hours": "Valandos",
    "label.type": "Tipas",
    "notifications.adventurous_journey_has_been_removed": "Žygis pašalintas",
    "label.aj_is_not_approved_yet": "Žygis nepatvirtintas",
    "roles.authorizing_contact": "Įgaliotas kontaktinis asmuo",
    "table.date_submitted_to_office_signoff": "Apdovanojimo lygio patvirtinimo data",
    "notifications.section_has_been_returned": "Dalis peržiūrėta",
    "table.created_by": "Sukurta",
    "route.user_guide_web_participant": "Elektroninis naudotojo vadovas - dalyvis",
    "route.templates": "Šablonai",
    "states.awaiting_sign_off": "DofE vadovo patvirtinimas",
    "table.phone": "Telefono numeris",
    "label.parental_consent": "tėvų sutikimas",
    "label.org_contact_will_be_deleted": "",
    "route.bronze_level": "Bronzos lygis",
    "label.invoice_currency": "Sąskaitos - faktūros valiuta",
    "button.new_label": "",
    "error.server_cannot_be_reached_at_the_moment": "Šiuo metu serveris nepasiekiamas. Pabandykite dar kartą vėliau. Jei problema išlieka, susisiekite su mūsų aptarnavimo komanda",
    "notifications.contact_has_been_created": "Kontaktas sukurtas",
    "pageTitle.profile_questions": "Profilio klausimai",
    "table.observation_files": "Tyrinėjimo dokumentai",
    "table.participants": "Dalyviai",
    "tasks.no_evidence": "Nėra įrodymo",
    "button.edit": "Redaguoti",
    "moduleTitle.leader": "DofE vadovas",
    "notifications.new_template_has_been_updated": "Naujas šablonas atnaujintas",
    "table.name": "Vardas",
    "label.no_results": "Nėra duomenų",
    "moduleTitle.documents": "Dokumentai",
    "button.invite": "Pakviesti",
    "label.goal": "Tikslas",
    "pageTitle.nao_award_units": "DofE Lietuva - DofE organizacijos",
    "label.award_delete_participant_id": "",
    "errors.at_least_num_characters": "Bent (lenght} ženklai",
    "label.email_help_note": "",
    "label.person_status.activating": "",
    "moduleTitle.remove_role": "Pašalinti vaidmenį?",
    "label.total": "Iš viso",
    "label.delete_participant_award_info": "",
    "route.leaders": "DofE vadovai",
    "table.start_date": "Pradžios data",
    "moduleTitle.coordinators": "Koordinatoriai",
    "button.create": "Kurti",
    "tabs.awards": "Apdovanojimai",
    "parentalConsent.form_has_been_sent": "Tėvų sutikimas išsiųstas.",
    "states.journey_approval": "Žygio patvirtinimas",
    "pageTitle.reports": "Ataskaita",
    "table.journey_type": "Žygio tipas",
    "label.yes": "Taip",
    "pageTitle.assessor_report": "Vertintojo ataskaita",
    "label.organization": "Organizacija",
    "notifications.award_leader_has_been_updated": "DofE vadovas atnaujintas",
    "moduleTitle.edit_role": "Redaguoti rolę",
    "table.journey_activity": "Žygio veikla",
    "label.location": "Vieta",
    "label.update_translations_error_item": "",
    "pageTitle.adventurous_journeys": "Žygiai",
    "global.assessor": "Vertintojas",
    "moduleTitle.profile_questions": "Profilio klausimai",
    "activity.cannot_edit_activity_if_award_in_state": "Negalima redaguoti veiklos, jei Apdovanojimas yra {state} būsenoje",
    "moduleTitle.assessor_detail": "Vertintojo duomenys",
    "parentalConsent.i_understand_that_upon_acceptance_into": "10. Suprantu, kad Apdovanojimo lygio siekiantis dalyvis gaus prisijungimą prie e-DofE platformos. Prieš pradėdamas veiklas dalyvis perskaitys DofE programos reikalavimus, pateiktus e-DofE platformoje. Suprantu, kad DofE organizacija nustato, ar dalyvis atitinka reikalavimus, leidžiančius siekti Bronzos, Sidabro arba Aukso ženklelio. Suprantu, kad Nacionalinis DofE Lietuva biuras suteikia ribotą draudimą nelaimės atveju bei draudimą, kai dalyvis yra priimtas į DofE organizaciją, tačiau už visus asmeninius nutikimus atsakomybę prisiima dalyvis/ir jo tėvai/globėjai.",
    "notifications.award_has_been_returned": "Apdovanojimas peržiūrėtas",
    "label.code_of_conduct": "",
    "button.new_contact": "Naujas kontaktas",
    "tabs.payments": "Mokėjimai",
    "roles.naa_oa_staff": "NAA OA Personalas",
    "label.switch_organisation_hint": "Galite atidaryti šį pokalbį bet kuriuo metu pasirenkant \"Pakeisti organizaciją\" viršutiniame dešiniajame meniu kampe",
    "label.expiration_date": "Pabaigos data",
    "tabs.participants": "Dalyviai",
    "table.practice": "Bandymas",
    "notifications.one_activity_has_to_remain": "Kiekvienoje dalyje privalo būti po vieną veiklą.",
    "label.qualifications": "Kvalifikacijos",
    "states.organization_approval": "DofE Lietuva patvirtinimas",
    "errors.must_be_an_integer": "\n Must be an integer",
    "participant.send_confirmation_email_again_question": "Siųsti patvirtinimo laišką dar kartą?",
    "button.dismiss": "Praleisti",
    "table.advice": "",
    "label.years_of_working_experience": "Darbinė patirtis metais",
    "notifications.search_failed": "Ieškant įvyko klaida. Pabandykite vėliau.",
    "notifications.changes_have_been_saved": "Pakeitimai buvo išsaugoti",
    "moduleTitle.resend_parental_consent_link": "Persiųsti tėvų sutikimo nuorodą?",
    "label.activity_type": "Veiklos tipas",
    "label.change_award": "Pakeisti Apdovanojimo lygį",
    "label.email": "El. pašto adresas",
    "button.remove": "Pašalinti",
    "button.download": "Parsisiųsti",
    "label.vat_treatment": "PVM mokestis",
    "pageTitle.aj_template_new": "Naujo žygio šablonas",
    "table.per_page": "per puslapį",
    "notifications.translations_has_been_updated": "",
    "notification.award_mode_has_been_updated": "Apdovanojimo režimas atnaujintas",
    "tasks.revise_item": "Peržiūrėti elementą",
    "button.resend_parental_consent": "Persiųsti tėvų sutikimą",
    "table.weeks_completed_required": "Pabaigtos savaitės",
    "label.last_modified": "Paskutinį kartą keistas",
    "table.major": "Pagrindinė",
    "label.vat_number": "PVM mokėtojo numeris",
    "errors.passwords_dont_match": "Slaptažodžiai neatitinka",
    "table.country": "Šalis",
    "sidebar.guides_and_policies": "",
    "notifications.question_has_been_updated": "Klausimas buvo atnaujintas",
    "table.participant_name": "",
    "label.registration_approval_date": "",
    "notifications.auth_code_is_no_longer_valid": "Autorizacijos kodas nebegalioja",
    "errors.must_be_no_more_than": "Turi turėti ne daugiau nei {max} ženklus",
    "notifications.event_has_been_rejected": "Įvykis peržiūrėtas",
    "tabs.customizations": "Pritaikymo priemonės",
    "label.name_organization": "Vardas",
    "button.add_log": "Pridėti įrašą",
    "moduleTitle.invite_assessor": "Pakviesti vertintoją",
    "label.resend_confirmation_email": "",
    "text.all_participants_will_be_transfered": "Visiems dalyviams paskirtas naujas DofE vadovas",
    "label.repeat_email": "Pakartoti el. pašto adresą",
    "errors.email_or_phone_required": "",
    "notifications.role_has_been_updated": "Vaidmuo atnaujintas",
    "roles.if_staff_stat_user": "Statistinis naudotojas",
    "participant.delete_account": "Ištrinti paskyrą",
    "moduleTitle.would_you_like_to_remove_this_log": "Norite ištrinti šį įrašą?",
    "sidebar.sgops": "",
    "label.prepare_new_email": "",
    "table.journey_category": "Žygio tipas",
    "sidebar.manual_data_import": "Rankinis duomenų importavimas",
    "label.created_after_date": "Sukurta po",
    "route.my_organization": "Mano organizacija",
    "button.show_list": "",
    "label.leaders": "Vadovai",
    "notifications.log_has_been_modified": "Įrašas koreguotas",
    "button.upload_file": "Įkelti dokumentą",
    "moduleTitle.which_section_do_you_want_to": "Kurią dalį norite grąžinti į būseną \"procese\"?",
    "tabs.bronze_level": "Bronzos lygis",
    "notifications.participants_have_been_saved": "Dalyviai išsaugoti",
    "pageTitle.aj_template_detail": "Žygis",
    "label.parent_email": "Tėvų/globėjų  el. pašto adresas",
    "map.appr_location": "Artimas adresas",
    "notifications.log_has_been_removed": "Įrašas pašalintas",
    "notifications.label_has_been_assigned": "",
    "pageTitle.tasks_undelivered_emails": "",
    "button.stay": "Pasilikti",
    "table.previous_level": "Praeitas lygis",
    "label.award_start_date": "Apdovanojimo lygio pradžios data",
    "assessor_report.returned_to_participant": "Grąžintas dalyviui",
    "pageTitle.tasks_assessors_registration": "Vertintojo registracija",
    "aj.cannot_modify_award": "Negalite keisti Apdovanojimo lygio, jei dalyviui nepaskirtas DofE vadovas.",
    "moduleTitle.lost_internet_connection": "Praradote interneto ryšį",
    "states.ceremony": "Ceremonija",
    "participant.reactivate_account": "Atnaujinti paskyrą",
    "label.birthdate": "Gimimo data",
    "pageTitle.assessment_send_successfully": "Įvertinimas sėkmingai išsiųstas",
    "states.assessor_approval": "Vertintojo patvirtinimas",
    "award.change_award_level": "Pakeisti Apdovanojimo lygį",
    "label.url_no_longer_valid": "Ši nuoroda nebegalioja.",
    "button.update": "Atnaujinti",
    "label.secondary_email": "Antras el. pašto adresas",
    "button.role_edit": "Redaguoti",
    "table.award_leader": "DofE vadovas",
    "label.level": "Lygis",
    "tasks.evidence": "Įrodymas",
    "notifications.participant_is_already_in_list": "Dalyvis jau yra sąraše",
    "button.clear": "Išvalyti",
    "label.allow_log_after_25_yoa": "",
    "states.setup": "Tikslo nustatymas",
    "table.activity": "Veikla",
    "label.copy_to_clipboard": "",
    "route.award_units": "DofE organizacijos",
    "button.upload_photo": "Įkelti paveiksliuką",
    "table.hours_completed_required": "Suvestos valandos",
    "table.first_name": "Vardas",
    "notifications.adventurous_journey_has_been_returned": "Žygis peržiūrėtas",
    "pageTitle.national_offices": "Nacionaliniai centrai",
    "notifications.you_have_been_logged_in": "Jūs buvote priregistruotas",
    "logs.offline": "",
    "moduleTitle.add_role": "Pridėti vaidmenį",
    "label.user_app_guide_participant": "Naudotojo aplikacijos vadovas - dalyvis",
    "notifications.file_has_been_removed": "Failas pašalintas",
    "label.send_message": "",
    "button.select": "Pasirinkti",
    "label.reason_of_deletion": "Ištrynimo priežastis",
    "label.user_guide": "Vartotojo vadovas",
    "pageTitle.nao_participants": "DofE Lietuva - Dalyviai",
    "tabs.sub_operating_partners": "",
    "table.uploaded_by": "Įkeltas",
    "tasks.approve_item": "Patvirtinti elementą",
    "tasks.restore_participant_registration": "Atkurti dalyvio registraciją?",
    "label.awardMode.hybrid": "Mišrus",
    "table.first_activity_started": "Pirma veikla pradėta",
    "moduleTitle.dates": "Datos",
    "table.no_results": "Nerasta duomenų",
    "states.registration_approval": "Registracijos patvirtinimas",
    "table.breakdown_of_hours": "Valandų paskirstymas",
    "pageTitle.tasks_registration": "Dalyvio registracija",
    "button.create_new": "Kurti naują",
    "sidebar.todolist": "Būtini padaryti darbai",
    "label.active_participants": "Aktyvūs dalyviai",
    "moduleTitle.postalAddress": "",
    "tasks.return_task": "Grąžinti peržiūrai",
    "organisation.change_organisation_state": "Pakeisti organizacijos būseną",
    "moduleTitle.roles": "Rolės",
    "label.no_config_key_available": "Šiame skyriuje nėra jokių konfigūracijos raktų",
    "placeholder.selectLanguage": "",
    "states.office_signoff": "DofE Lietuva patvirtinimas",
    "notifications.translations_has_been_updated.failure": "",
    "logs.minute": "minutė",
    "label.last_activity": "Paskutinė veikla",
    "sidebar.user_guide": "Vartotojo vadovas",
    "label.trained_award_leader": "Apmokytas DofE vadovas",
    "table.progress": "Progresas",
    "table.suboperating_authorities": "DofE Lietuva partneriai",
    "activity.cannot_edit_activity_offline": "Šis dalyvis veikia neprisijungęs(-usi).<br><br>\nJūs negalite redaguoti veiklos, žygio ar Aukso rezidavimo projekto, jei esate neprisijungęs(-usi).",
    "label.user_does_not_have_permissions": "Vartotojas <strong>{user}</strong>  neturi prieigos prie šių duomenų.",
    "notifications.assessor_has_been_approved": "Vertintojas patvirtintas",
    "route.activity_approval": "Veiklos patvirtinimas",
    "moduleTitle.role": "Vaidmuo",
    "button.run": "Diegti",
    "label.to": "To",
    "notifications.file_has_been_updated": "Failas atnaujintas",
    "moduleTitle.edit_coordinator": "Redaguoti koordinatorių",
    "notifications.authorization_code_is_no_longer_valid": "Patvirtinimo kodas nebegalioja",
    "button.reject": "Atmesti",
    "label.label.participant_status": "Dalyvio statusas",
    "award.gold_level": "Aukso lygis",
    "sidebar.variables": "Kintamumas",
    "parentalConsent.checkbox_copy": "Patvirtinu, kad esu {firstName} {lastName} tėvas/globėjas. Suteikiu jam/jai leidimą dalyvauti DofE programoje {organizationName}, kurioje DofE vadovas yra {awardLeader}. Aš perskaičiau, suprantu ir sutinku su dalyvavimo programoje reikalavimais ir sąlygomis, kurios yra pateiktos aukščiau ir aprašytos tinklapyje.",
    "button.go_to_dashboard": "Eiti į pagrindinį puslapį",
    "button.add_option": "Pridėti pasirinkimus",
    "label.is_completed": "Baigta",
    "pageTitle.award_units": "DofE organizacija",
    "states.completed": "Baigta",
    "button.adventurous_journey_template_settings": "Žygio kortelės nustatymai",
    "label.system_rights": "Sistemos tvarka",
    "label.assessor_assesstment_award_start_date": "",
    "label.update_translation_question": "",
    "button.login": "Prisijungti",
    "label.name_of_the_unit": "Organizacijos pavadinimas",
    "button.send": "Siųsti",
    "award.ajs": "Žygiai",
    "meta.payments_expired": "Mokėjimai - nebegalioja",
    "label.age": "Amžius",
    "notifications.payment_info_updated": "Informacija apie mokėjimą atnaujinta",
    "table.is_completed": "Baigta",
    "table.invited_by": "Pakviestas",
    "route.files": "Dokumentai",
    "route.assessors": "Vertintojai",
    "info.aj_supervisor_is_mandatory": "",
    "pageTitle.my_participants": "Mano dalyviai",
    "label.change_leader_status": "Pakeisti vadovo statusą",
    "moduleTitle.parent_consent_form": "Tėvų/globėjų sutikimo forma",
    "notifications.authorization_contact_has_been_set": "Patvirtinimo kontaktai nustatyti",
    "button.close": "Uždaryti",
    "label.independent_country": "Neriklausoma šalis",
    "notifications.aj_preparation_training_has_been_returned": "Pasirengimas ir mokymasis žygiui grąžinti peržiūrai",
    "route.history_log": "Senesni įrašai",
    "participant.account_settings": "Paskyros nustatymai",
    "label.bulk_action_error_item": "",
    "label.orb_account": "",
    "notifications.file_url_is_not_specified_in_configuration": "Dokumento url adresas nenurodytas konfigūracijoje",
    "notifications.award_unit_has_been_removed": "DofE organizacija pašalinta",
    "table.parent": "Tėvas",
    "label.mode_of_transport": "Trasnporto rūšis",
    "label.parental_consent_email_info": "Nepamirškite patikrinti pirminio laiško ir nusiųsti tėvų sutikimą rankiniu būdu",
    "label.current_award": "Dabartinis Apdovanojimo lygis",
    "table.action": "Veikla",
    "pageTitle.suboperating_authorities": "DofE Lietuva partneriai",
    "notifications.award_leader_has_been_assigned": "DofE vadovas nustatytas",
    "tabs.sign_offs_locally": "Vietiniai patvirtinimai",
    "Activity log has been restored": "pranešimas. prisijungimas atkurtas",
    "sidebar.naos": "Nacionaliniai DofE biurai",
    "tabs.aj_templates": "Žygio šablonai",
    "notifications.logging_out": "Išsiregistruojama",
    "label.update_label": "",
    "button.organisation_settings": "Organizacijos nustatymai",
    "tabs.independent_award_centers": "Nepriklausomos DofE organizacijos",
    "label.current": "",
    "table.location": "Vieta",
    "button.search": "Ieškoti",
    "notifications.aj_preparation_training_has_been_approved": "Pasirengimas ir mokymasis žygiui patvirtintas",
    "route.participants": "Dalyviai",
    "label.other_location_information": "Kita vietos informacija",
    "label.number_of_records": "Įrašų skaičius",
    "translationsManagement.infoLabel": "",
    "parentalConsent.i_consent_to_pay_all": "5. Nelaimės, ligos ar patirtų nuostolių atvejais, patirtais vykdant DofE programą, sutinku sumokėti visas gydymo ir kitas išlaidas. ",
    "label.nationality": "Tautybė",
    "states.approval": "Tikslo patvirtinimas",
    "notifications.something_went_wrong": "Kažkas negerai",
    "aj.practice": "Bandomasis",
    "label.addressLine2": "Adresas 2",
    "label.please_leave_a_note": "Prašome palikti žinutę",
    "placeholder.select": "Pasirinkti",
    "label.observations": "Pastebėjimai",
    "label.aim": "Tikslas",
    "label.addressLine1": "Adresas 1",
    "roles.aj_instructor": "Žygio instruktorius",
    "meta.payments_waiting": "Mokėjimai - laukiama",
    "label.award_to_delete": "",
    "label.category": "",
    "roles.instructor": "Instruktorius",
    "moduleTitle.remove_customization_and_reset": "Pašalinti patvirtinimą ir atstatyti konfigūravimo reikšmę?",
    "notifications.participant_registration_has_been_restored": "Dalyvio registracija atkurta",
    "organisation.change_award_unit_mode": "Keisti organizacijos režimą",
    "table.organization_type": "",
    "notifications.participant_has_been_deleted": "Dalyvis ištrintas",
    "label.language_settings": "Kalbos nustatymas",
    "notifications.event_has_been_approved": "Įvykis patvirtintas",
    "label.password": "Slaptažodis",
    "label.text": "Tekstas",
    "table.observations": "Tyrinėjimai",
    "notifications.participant_has_been_created": "Dalyvis sukurtas",
    "table.note_for_al": "Žinutė DofE vadovui",
    "label.payment_confirmed": "Mokėjimas patvirtintas",
    "label.previous_completed_award_level": "Ankstesnis lygis (ne EPK)",
    "pageTitle.new_aj_event": "Nauji žygio įvykiai",
    "label.backend": "",
    "label.relationship_to_participant": "Santykis su dalyviu",
    "award.physical_recreation": "Aktyvi veikla",
    "contact.collect_emails": "",
    "moduleTitle.assessor_report_reject": "Vertintojo ataskaita atmesta",
    "label.supervisor_report": "Žygio vadovo ataskaita",
    "table.role": "Vaidmuo",
    "route.user_guide_web_nao": "Elektroninis naudotojo vadovas - DofE Lietuva",
    "label.page_not_found": "404 - puslapis nerastas",
    "table.labels": "",
    "notifications.file_has_been_uploaded": "Failas įkeltas",
    "moduleTitle.address": "Adresas",
    "moduleTitle.lead_coordinator": "Pagrindinis koordinatorius",
    "pageTitle.login": "Prisijungti",
    "label.frontoffice": "",
    "participant.would_you_like_to_remove_registration": "",
    "notifications.rp_has_been_setup": "Aukso rezidavimo projektas nustatytas ",
    "moduleTitle.award_unit": "DofE organizacija",
    "button.remove_file": "Pašalinti failą",
    "moduleTitle.billing_address": "Billing Address",
    "pageTitle.my_aj_events": "Mano žygio įvykiai",
    "route.tasks": "Užduotys",
    "button.confirm": "Patvirtinti",
    "label.national_award_authority": "DofE Lietuva",
    "label.independent_award_centre": "Nepriklausoma DofE organizacija",
    "award.generate_award_report": "Sugeneruoti ataskaitą",
    "route.my_region_office_customization": "Mano regiono biuras - pritaikymas",
    "label.email_help_aj_category": "",
    "label.your_report_has_been_rejected": "",
    "notifications.password_change_request_has_been_sent": "Prašymas pakeisti slaptažodį išsiųstas",
    "tabs.detail": "Duomenys",
    "participant.change_participant_status": "Keisti dalyvio statusą",
    "table.key": "",
    "label.find_address": "Rasti adresą",
    "notifications.assessor_has_been_rejected": "Vertintojas atmestas",
    "label.transfer_participants": "Perkelti dalyvius",
    "button.continue_to_payment_gateway": "Tęsti ir mokėti už programą",
    "notifications.participant_registration_has_been_removed": "Dalyvio registracija buvo pašalinta",
    "moduleTitle.page_not_found": "404 - puslapis nerastas",
    "route.adventurous_journeys": "Žygiai",
    "states.registration_assessment": "DofE vadovo priskyrimas",
    "heading.change_award_unit_mode": "Keisti DofE organizacijos režimą",
    "label.user_guide_web_nao": "Elektroninis naudotojo vadovas - DofE Lietuva",
    "tabs.silver_level": "Sidabro lygis",
    "table.paid_by": "Sumokėta",
    "label.your_report_has_been_successfully_sent": "Jūsų ataskaita sėkmingai išsiųsta.",
    "sidebar.my_organization": "Mano organizacija",
    "pageTitle.participants": "Dalyviai",
    "notifications.preparation_training_has_been_updated": "Pasiruošimas ir žygio planavimas atnaujinti",
    "moduleTitle.server_is_unreachable": "Serveris nepasiekiamas",
    "label.last_activity_date": "",
    "award.bronze_level": "Bronzos lygis",
    "moduleTitle.award_units": "DofE organizacijos",
    "table.completed": "Baigta",
    "moduleTitle.revise_message": "Peržiūrėti pranešimą",
    "table.lastUsed": "",
    "award.bronze_to_gold_level": "Bronzos lygis į Aukso lygį",
    "button.change_password": "Keisti slaptažodį",
    "label.nao_price": "DofE Lietuva mokestis",
    "label.payment_state": "Mokėjimo statusas",
    "label.wwc_expired": "WWC expired",
    "label.award_office_signoff_date": "DofE Lietuva komandos patvirtinimo data",
    "label.award_unit": "DofE organizacija",
    "award.gold_level_short": "Auksas",
    "moduleTitle.other_info": "Kita informacija",
    "table.note": "Žinutė",
    "label.search_by_email_first_or_last": "Ieškoti pagal el. pašto adresą, vardą arba pavardę",
    "tabs.history": "Istorija",
    "notifications.label_has_been_created": "",
    "tabs.unassigned_participants": "Nepaskirti dalyviai",
    "table.main_award_leader": "Pagrindinis DofE vadovas",
    "parentalConsent.i_as_the_parent": "3. Suprantu, kad kai kurios veiklos priklauso didelės rizikos grupei ir tokios veiklos negali būti apdraustos DofE Lietuva biuro. Suprantu, kad dalyvis prisiima visą atsakomybę dėl nelaimingų atsitikimų programos vykdymo metu.",
    "label.state": "Būsena",
    "notifications.award_leader_has_been_removed": "DofE vadovas pašalintas",
    "tabs.organization_detail": "Organizacijos duomenys",
    "table.operating_authorities": "DofE Lietuva partneriai",
    "label.available_labels": "",
    "modal.select": "Pasirinkti",
    "tabs.expired_payments": "Pasibaigęs laikas mokėjimams",
    "moduleTitle.note_for_al": "Žinutė DofE vadovui",
    "moduleTitle.confirm": "Patvirtinti",
    "notification.new_activity_added": "Pridėta nauja veikla",
    "notifications.award_leader_has_been_moved": "DofE vadovas perkeltas",
    "label.award_mode": "Apdovanojimo režimas",
    "label.phone": "Telefono numeris",
    "notifications.organization_has_been_updated": "Organizacija atnaujinta",
    "moduleTitle.assessor": "Vertintojas",
    "label.bulk_action_confirmation": "",
    "table.parent_approval": "Tėvų patvirtinimas",
    "label.date_of_delivery": "Pristatymo data",
    "sidebar.assessors": "Vertintojai",
    "label.journey_activity": "Žygio veikla",
    "award.inactive_award": "Neaktyvus Apdovanojimo lygis",
    "label.end_date": "Pabaigos data",
    "label.orb_testing": "",
    "label.no_activities": "Nėra veiklų",
    "moduleTitle.please_confirm": "Prašome patvirtinti",
    "button.login_with_another_account": "Prisijungti su kita paskyra",
    "tasks.reject_registration": "Atmesti registraciją",
    "label.submitted_after_date": "Įkelta po",
    "label.update_translations_successful": "",
    "button.assign_leader": "Paskirti DofE vadovą",
    "table.already_running": "Vykdoma",
    "label.no": "Ne",
    "label.count_items_selected": "",
    "label.secondary_phone_number": "Antras telefono numeris",
    "label.my_experience": "Mano patirtis",
    "notifications.adventurous_journey_has_been_approved": "Žygis patvirtintas",
    "pageTitle.mro_detail": "Mano regiono centras - Detalės",
    "moduleTitle.nao_specific_info": "DofE Lietuva informacija",
    "label.preparing_document_for_import": "Dokumento paruošimas importavimui",
    "tasks.observations": "Stebėjimai",
    "notifications.confirmation_email_has_been_sent": "Patvirtinimo laiškas buvo išsiųstas",
    "button.restore": "Atkurti",
    "label.importing_file": "Failo importavimas",
    "label.or_dont_agree": "Ar nesutikti? Jūs galite",
    "moduleTitle.award_leader": "Vadovas",
    "label.me": "(aš)",
    "tabs.sub_global_operating_partners": "",
    "button.export_table": "Perkelti lentelę",
    "organisation.move_award_unit": "Perkelti DofE organizaciją",
    "label.file_category": "",
    "notifications.connecting_to_server": "Jungiamasi prie serverio",
    "parentalConsent.i_understand_that_a_and_b": "11. Suprantu, kad: <br /> a. dalyvis negali vairuoti transporto priemonės ar ja vežti kitus dalyvius į veiklas, susijusias su DofE programa, jei dalyvis neturi galiojančio vairuotojo pažymėjimo bei draudimo, kuris yra reikalingas nelaimės atveju. ; ir <br /> b. dalyvis negali būti vežamas į veiklas asmens, kuris nėra susijęs su DofE programa, nebent asmuo turi galiojantį vairuotojo pažymėjimą bei draudimą, kuris yra reikalingas nelaimės atveju. ",
    "table.reason": "",
    "pageTitle.contacts": "Kontaktai",
    "states.award_leader_approval": "DofE vadovo patvirtinimas",
    "meta.payments": "Mokėjimai",
    "label.suboperating_authority": "DofE Lietuva partneris",
    "route.my_region_office": "Mano regiono biuras",
    "states.registration_not_approved": "Registracija nepatvirtinta",
    "label.direct_entrant": "Tiesioginis priėmimas",
    "tabs.all_participants": "Visi dalyviai",
    "tabs.payment": "Mokėjimas",
    "label.email_help_activity_name": "",
    "title.update_report": "",
    "label.repeat_new_password": "Pakartoti naują slaptažodį",
    "label.other_roles": "",
    "logs.hours": "valandos",
    "notifications.spreadsheet_has_been_imported_successfully": "Skaičiuoklė sėkmingai importuota",
    "label.bulk_action_question": "",
    "moduleTitle.personal_details": "Asmeniniai duomenys",
    "label.bulk_action_emailing": "",
    "route.my_events": "Mano įvykiai",
    "button.delete_award": "",
    "errors.include_both_lower_and_upper_case": "Įtraukite mažąsias ir didžiąsias raides",
    "tabs.removed_participant_registrations": "Pašalinti dalyvių registracijų duomenys",
    "sidebar.mynao": "Mano nacionalinis DofE centras",
    "tabs.office_details": "Biuro duomenys",
    "label.major": "Pagrindinė",
    "tabs.documents": "Dokumentai",
    "label.new_password": "Naujas slaptažodis",
    "sidebar.adventure_journey": "Žygis",
    "pageTitle.customizations": "Pritaikymo priemonės",
    "moduleTitle.assessor_report": "{role} ataskaita",
    "label.registration_date": "Registracijos data",
    "notifications.training_has_been_added": "Mokymasis pridėtas",
    "aj.qualifying": "Kvalifikacinis",
    "moduleTitle.you_have_been_logged_out_session_terminated": "Jūs buvote atjungtas, kadangi ilgą laiką platformoje neatlikote jokių veiksmų",
    "award.service": "Savanoriškos paslaugos",
    "notifications.rp_state_has_been_changed": "Aukso rezidavimo projekto būsena nustatyta",
    "label.ctest_access": "",
    "table.created": "Sukurta",
    "tasks.revise_task": "Peržiūrėti veiklą",
    "button.assign": "Paskirti",
    "button.return": "Grąžinti",
    "table.status": "Statusas",
    "button.restore_activity": "Atkurti veiklą",
    "tabs.new_aj_event": "Naujas žygio įvykis",
    "roles.if_staff_viewer": "Tarptautinio fondo personalo prižiūrėtojas",
    "notifications.new_template_has_been_created": "Naujas šablonas sukurtas",
    "global.something_went_wrong": "Kažkas negerai",
    "table.expire_day": "Pabaigos data",
    "tabs.history_log": "Senesni įrašai",
    "label.form_of_payment": "Mokėjimo forma",
    "button.add_training": "Pridėti apmokymą",
    "label.par_reg_cust_note": "",
    "label.my_qualification": "Mano kvalifikacija",
    "button.add_new_profile_question": "Pridėti naują profilio klausimą",
    "table.operating_authority": "DofE Lietuva partneris",
    "table.aim": "Tikslas",
    "table.awards": "Apdovanojimai",
    "participant.deactivate_account": "Panaikinti paskyrą",
    "table.organization_name": "",
    "label.email_help_award_leader_first_name": "",
    "table.date": "Data",
    "tasks.would_you_like_to_delete": "Ar norite ištrinti dalyvį?",
    "notifications.configuration_value_has_been_updated": "Dar kartą konfigūruota",
    "ajTemplates.fill_from_template": "Užpildyti šabloną",
    "contact.send_test_email": "Siųsti bandomąjį laišką",
    "moduleTitle.aj_preparation_and_training": "Žygio planavimas ir pasiruošimas",
    "label.ce_be": "",
    "button.notify_participant": "",
    "label.parent_phone": "Tėvų/globėjų telefono numeris",
    "label.nao_regulations": "",
    "award.skills": "Įgūdžiai",
    "label.reject_application": "atmesti šį prašymą.",
    "leader.delete_account": "Ištrinti paskyrą",
    "table.assign": "Nustatyti",
    "roles.aj_supervisor": "Žygio vadovas",
    "label.logout": "Atsijungti",
    "moduleTitle.award_leader_edit": "Redaguoti DofE vadovą",
    "moduleTitle.training": "Mokymasis",
    "notifications.coordinator_has_been_removed": "Koordinatorius buvo pašalintas",
    "tabs.operating_partners": "",
    "moduleTitle.main_award_leader": "Pagrindinis Vadovas/Koordinatorius",
    "label.bulk_action_successful": "",
    "tasks.clear_email_revision": "",
    "table.preparation": "Pasiruošimas",
    "table.delete": "Ištrinti",
    "label.safeguarding_policy": "",
    "sidebar.reports": "Ataskaitos",
    "pageTitle.sub_global_operating_partners": "",
    "label.is_major_activity_confirmation": "",
    "pageTitle.operating_authorities": "DofE Lietuva partneriai",
    "label.delete_participant_award_modal_question_detail": "",
    "label.confirmed": "Patvirtinta",
    "notifications.invitation_has_been_sent": "Pakvietimas išsiųstas",
    "pageTitle.independent_countries": "Nepriklausomos šalys",
    "label.assessors_email": "Vertintojo el. pašto adresas",
    "tasks.approve_assessor_registration": "Patvirtinti vertintojo registraciją",
    "table.award_duration": "Apdovanojimo lygio trukmė",
    "notifications.organization_has_been_moved": "Organizacijos buvo perkeltos",
    "pageTitle.nao_payment": "DofE Lietuva - Mokėjimas",
    "participant.history_log": "Senesni įrašai",
    "label.rejected_with_note": "",
    "label.already_running": "Jau vykdo",
    "button.continue": "",
    "award.no_data_to_show": "Nėra duomenų",
    "participant.send_email_invitation_again_question": "Siųsti pakvietimą dar kartą?",
    "label.reason_for_changing_assessor": "Priežastis, kodėl vertintojas buvo pakeistas",
    "button.delete": "Ištrinti",
    "moduleTitle.requirements_and_conditions": "Reikalavimai ir sąlygos",
    "roles.leader": "Vadovas",
    "label.if_download_doesnt": "Jei atsisiuntimas neprasideda automatiškai, patikrinkite naršyklės iššokančius nustatymus",
    "dashboard.your_todo_list": "Jūsų būtini padaryti darbai",
    "notifications.award_unit_has_been_returned": "DofE organizacija peržiūrėta",
    "moduleTitle.participant_activities": "Dalyvio veiklos",
    "errors.qualification_or_experience_required": "",
    "label.active_leaders": "Aktyvūs DofE vadovai",
    "aj.preparation": "Pasirengimas",
    "button.change_state": "Keisti būseną",
    "label.current_password": "Dabartinis slaptažodis",
    "pageTitle.global_operating_partners": "",
    "moduleTitle.contact_settings": "Kontaktų nustatymai",
    "button.remove_photo": "Pašalinti nuotrauką",
    "notifications.activity_has_been_setup": "Veikla nustatyta",
    "errors.must_be_more_than": "Turi būti didesnis nei {limit}",
    "table.goal": "Tikslas",
    "notifications.coordinator_has_been_set": "Koordinatorius paskirtas",
    "label.cc": "Cc",
    "label.duration": "Trukmė",
    "table.actions": "Įvykiai",
    "participant.send_email_invitation_again": "Siųsti pakvietimą dar kartą?",
    "moduleTitle.would_you_like_to_remove_participant": "Norite ištrinti dalyvį #{value}",
    "parentalConsent.i_authorise_employees": "4. Leidžiu darbuotojams, pareigūnams ar DofE organizacijos atstovams bei kitiems prie programos vykdymo prisidedantiems asmenims nelaimės atveju suteikti reikalingą medicininę įtraukiant, įskaitant, bet neapsiribojant gydytojais, slaugytojais ar gydymu ligoninėje. ",
    "button.reload_page": "Perkrauti puslapį",
    "moduleTitle.update_translations": "",
    "label.report_description": "",
    "table.email": "El. pašto adresas",
    "label.new_goal": "Naujas tikslas",
    "label.participant_survey_parent": "Sutinku, kad mano sūnui/dukrai {firstName} {lastName}, būtų suteikta galimybė dalyvauti DofE programos vykdomuose tyrimuose ir apklausose, kuriomis siekiama išmatuoti programos įtaką dalyvio asmeniniam ir įgūdžių tobulėjimui. Išsamesnė informacija apie DofE vykdomus tyrimus pateikiama <a href=https://www.dofe.lt/lt/news/dofe-tyrimai-229/>čia\n</a>",
    "errors.invalid_email_address": "Netinkamas el. pašto adresas",
    "pageTitle.new_contact": "Naujas kontaktas",
    "sidebar.gops": "",
    "button.manage_participants": "Vadovauti dalyviams",
    "errors.invalid_phone_format": "Netinkamas telefono numeris",
    "notifications.login_details_have_been_changed": "Prisijungimo detalės pakeistos",
    "moduleTitle.participant_logs": "Dalyvio prisijungimai",
    "label.save": "Išsaugoti",
    "label.frequently_asked_questions": "Dažniausiai užduodami klausimai (DUK)",
    "label.city": "Miestas",
    "notifications.configuration_value_has_been_reset": "Konfigūravimo reikšmė buvo nustatyta iš naujo",
    "states.office_sign_off": "DofE Lietuva patvirtinimas",
    "button.save": "Išsaugoti",
    "button.import_data_from_selected_file": "Importuoti duomenis iš pasirinkto failo",
    "parentalConsent.i_understand_that_the_participant_cannot": "9. Suprantu, kad dalyvis negali pradėti vykdyti veiklos, kol jo pasirinktas veiklos vertintojas nėra DofE organizacijos darbuotojas, nėra tinkamai pasiruošęs ar kvalifikuotas atlikti/prižiūrėti/vertinti DofE programos dalį; ir kol atitinkami savanoriai nėra pabaigę mokymų ar negrąžino dokumentų, įgaliojančių atlikti DofE programą.",
    "pageTitle.apiKeys": "",
    "label.international_region": "Tarptautinis regionas",
    "tabs.levels": "Lygiai",
    "tabs.additional_files": "Papildomi dokumentai",
    "label.continuation_level": "Tęsiamas lygis",
    "table.adventurous_journey_detail": "Žygio detalės",
    "button.set": "Nustatyti",
    "label.i_certify_that_as_the_assessor": "Kaip šios veiklos {role} patvirtinu, kad dalyvis atitinka reikalavimus.",
    "table.coordinator": "Koordinatorius",
    "participant.send_confirmation_email_again": "Siųsti patvirtinimo laišką dar kartą?",
    "table.report": "Ataskaita",
    "label.update_translations_results": "",
    "table.observation_note": "Pastebėjimai po peržiūrėjimo",
    "label.view_more": "Daugiau",
    "notifications.payment_link_has_been_reset": "Nuoroda mokėjimas nustatyta iš naujo",
    "table.type": "Tipas",
    "moduleTitle.updateConfigurationKey": "Iš naujo konfigūruoti",
    "sidebar.independent_award_centers": "Nepriklausomos DofE organizacijos",
    "table.activity_type": "Veiklos tipas",
    "label.awardMode.online": "Prisijungęs",
    "table.data_state": "",
    "button.generate_report": "Sugeneruoti ataskaitą",
    "moduleTitle.assessed_by_award_leader": "Vadovo įvertinimas",
    "table.child_protection_number": "vaikų apsaugos numeris",
    "button.bulk_change": "",
    "label.send_welcome_email": "",
    "label.award_state": "Apdovanojimo būsena",
    "moduleTitle.overview": "Peržiūra",
    "table.aj_detail": "Žygio detalės",
    "pageTitle.tasks_activity_approvals": "Veiklos patvirtinimas",
    "label.section": "Dalis",
    "route.history": "Istorija",
    "route.event_participants": "Įvykio dalyviai",
    "participant.account_detail": "Paskyros nustatymai",
    "route.dashboard": "Pagrindinis puslapis",
    "table.payments": "Mokėjimai",
    "pageTitle.profile": "Profilis",
    "organisation.remove_organisation": "Pašalinti organizaciją",
    "pageTitle.my_organization": "Mano organizacija",
    "label.award_leader": "",
    "notifications.assessor_has_been_updated": "Vertintojas atnaujintas",
    "label.participant_personal_reflection": "",
    "button.add_key": "",
    "header.appMotto": "Hercogas",
    "table.qualifying": "Kvalifikacinis",
    "button.upload": "Įkelti",
    "button.resend": "Persiųsti",
    "label.filename": "Failo pavadinimas",
    "label.change_parental_consent": "",
    "button.cancel": "Atšaukti",
    "label.aply_to_all_langs": "",
    "route.customization": "Pritaikomumas",
    "errors.minimal_duration_is": "Minimali trukmė 30 min",
    "label.email_help_participant_first_name": "",
    "label.participant_status": "Dalyvio statusas",
    "award.bronze_level_short": "Bronza",
    "label.phone_type": "Telefono tipas",
    "global.night": "naktis ",
    "button.adventurous_journey_settings": "Žygio nustatymai",
    "participant.leader_must_be_selected": "DofE vadovas turi būti pasirinktas",
    "pageTitle.translationsManagement": "",
    "moduleTitle.user_added_preparation_and_training": "Pridėtas naujas vartotojas prie žygio planavimo ir pasiruošimo",
    "table.approve": "Patvirtinti",
    "label.role_in_organisation": "Vaidmuo organizacijoje",
    "states.finished": "Baigta",
    "label.created": "Sukurtas",
    "button.back_to_home": "Grįžti",
    "label.options": "Pasirinkimai",
    "contact.next_level_invitation": "Pakvietimas į kitą lygį",
    "moduleTitle.activity_detail": "Veiklos detalės",
    "route.section_signoff": "Dalies patvirtinimas",
    "moduleTitle.assign_labels_bulk": "",
    "button.contact_settings": "Kontaktų nustatymai",
    "label.transation_id": "Pavedimo numeris",
    "notifications.activity_has_been_updated": "Veikla atnaujinta",
    "sidebar.awards": "Apdovanojimai",
    "parentalConsent.images_consent": "Kaip tėvas/globėjas, suteikiu teisę DofE Lietuva komandai naudoti nuotraukas programos viešinimo tikslais.",
    "participant.would_you_like_to_delete": "Norite ištrinti šią paskyrą?",
    "roles.user": "Vartotojas",
    "label.label": "",
    "label.select_sheet": "",
    "global.no_results": "Nėra duomenų",
    "moduleTitle.address_line_2": "Adresas 2",
    "states.awaiting_office_sign_off": "DofE Lietuva patvirtinimas",
    "moduleTitle.export": "Perkelti",
    "moduleTitle.address_line_1": "Adresas 1",
    "notifications.participant_has_been_assigned": "Dalyvis paskirtas",
    "roles.viewer": "Žiūrovas",
    "label.participants_total": "Visas dalyvių skaičius",
    "errors.auth_code_is_no_longer_valid": "Prisijungimo kodas nebegalioja - jis jau yra panaudotas arba baigėsi jo galiojimo laikas",
    "label.file_is_not_available": "Failas nepasiekiamas",
    "button.select_template": "Pasirinkti šabloną",
    "label.payment": "Mokėjimai",
    "award.silver_level_short": "Sidabras",
    "table.participant_id": "",
    "text.hours_old": "",
    "moduleTitle.your_personal_information": "Jūsų asmeninė informacija",
    "aj.minimum_date_recommendation": "Rekomenduojama bandomojo žygio data ir {name} yra",
    "label.date_of_payment": "Mokėjimo data",
    "button.view": "Žiūrėti",
    "label.create_new_label": "",
    "title.confirmation": "",
    "button.set_participants": "Nustatyti dalyvį",
    "roles.assessor": "Vertintojas",
    "moduleTitle.coordinator_settings": "Koordinatoriaus nustatymai",
    "label.parent_relationship": "Tėvų santykiai",
    "table.nao": "DofE Lietuva",
    "notifications.email_has_been_sent": "laiškas išsiųstas",
    "label.email_help_participant_full_name": "",
    "sidebar.suboperating_authorities": "DofE Lietuva partneriai",
    "route.award": "Apdovanojimai",
    "label.no_roles": "Nėra vaidmens",
    "table.files": "Failai",
    "aj.minimum_date_requirements": "Minimalus laikas skirtas kvalifikaciniam žygiui ir {name}",
    "pageTitle.labels": "",
    "label.participant_is_semi_offline": "Dalyvis neprisijungęs",
    "moduleTitle.other_coordinators": "Kiti koordinatoriai",
    "button.updateSelectedLanguage": "",
    "tasks.approve_award_registration": "Patvirtinti Apdovanojimo lygio registraciją",
    "participant.invite_participant_to_next_level": "Pakviesti dalyvį į kitą lygį?",
    "label.twitter": "Twitter",
    "pageTitle.awards": "Apdovanojimai",
    "warning.award_marked_as_paid": "",
    "table.edit": "Redaguoti",
    "states.change_to_state_warning_missing_hours_to_complete": "",
    "label.dofe": "Tarptautinis Apdovanojimas",
    "moduleTitle.after_assigning_a_role_to_yourself": "Priskirdami arba keisdami sau vaidmenį, turėsite prisijungti dar kartą",
    "label.transaction_id": "Pavedimo ID",
    "table.suboperating_authority": "DofE Lietuva partneris",
    "label.participant_survey": "Kaip DofE dalyvis/-ė, džiaugiuosi galėdamas/-a dalyvauti Fondo apklausose",
    "label.created_by": "Sukurtas",
    "button.send_confirmation_email_again_question": "Siųsti el. pašto patvirtinimo laišką dar kartą",
    "label.email_help_award_leader_email": "",
    "label.name": "Vardas",
    "tabs.gold_level": "Aukso lygis",
    "pageTitle.award_documents": "Apdovanojimams reikalingi dokumentai",
    "label.online_payments": "Elektroniniai mokėjimai",
    "label.child_protection_number": "Vaikų apsaugos numeris",
    "participant.send_password_recovery_email": "Siųsti slaptažodžio atnaujinimą dar kartą?",
    "notifications.new_log_has_been_added": "Naujas įrašas pridėtas",
    "moduleTitle.add_gop_role": "",
    "label.organization_name": "Organizacijos pavadinimas",
    "pageTitle.my_organization_templates": "Mano organizacija - Šablonai",
    "pageTitle.award_leaders": "Vadovai",
    "label.status": "Būsena",
    "label.street": "Gatvė",
    "roles.if_staff_superuser": "Tarptautinio fondo personalas",
    "table.licence_holder": "Licencijos turėtojas",
    "label.created_at": "Sukurtas",
    "table.section": "Dalis",
    "table.system_rights": "Sistemos tvarka",
    "label.iac_type": "Tarptautinio DofE centro tipas",
    "label.other": "Kita",
    "moduleTitle.login": "Prisijungti",
    "label.no_data_to_show": "Nėra duomenų",
    "aj.cannot_modify_award_level_if_participants_are_assigned": "Negalima keisti Apdovanojimo lygio, jei dalyviui yra paskirtas žygis.",
    "tabs.waiting_payments": "Laukiama apmokėjimų",
    "global.supervisor": "Žygio vadovas",
    "notifications.new_role_has_been_added": "Naujas vaidmuo pridėtas",
    "award.silver_level": "Sidabro lygis",
    "heading.change_awards_mode": "Keisti Apdovanojimo režimą",
    "button.save_changes": "Išsaugoti pakeitimus",
    "organisation.would_you_like_to_move_award_unit": "Kur norėtumėte perkelti šią organizaciją?",
    "label.fields": "",
    "label.email_help_organization_name": "",
    "pageTitle.mro_related_detail": "Mano regiono centras - Duomenys",
    "table.started_at": "Pradėta",
    "parentalConsent.i_consent_to_the_award_unit": "2. Sutinku, kad DofE organizacija, ar kiti asmenys (įskaitant savanorius), kurie dalyvauja ar padeda vykdyti DofE programą bei pasamdyti vairuotojai, gali nuvežti dalyvį į vietas, kuriose bus atliekama veikla ar atlikti su programa susijusias veiklas. Suprantu, kad DofE organizacija praneš iš anksto kur ir kada tokia kelionė vyks.",
    "logs.minutes": "minutės",
    "label.total_participants": "Visi dalyviai",
    "moduleTitle.contact_info": "Kontaktinė informacija",
    "table.payment_link": "Nuoroda mokėjimui",
    "errors.please_contact_your_local_award_staff": "Prašome susisiekti su vietiniu DofE programą vykdančiu personalu"
}